import template from './documents.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class GeneralDocumentsViewModel
{
	constructor(page)
	{
		this.page = page;
		this.general_documents = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.doc_types = ko.observableArray();
		this.alert_message = ko.observable();

		this.add_general_document = this.add_general_document.bind(this);
		this.save_document = this.save_document.bind(this);
		this.delete_document = this.delete_document.bind(this);
	}

	generalDocumentsRenderedHandler()
	{
		window.Grape.update_visible_roles(); // this gets run multiple times - might have to fix this so its only run once everything is rendered
		Utils.refresh_data_visible_roles();
	}

	async add_general_document()
	{
		await Grape.dialog.open('UploadGeneralDocument', {});
		this.page.updateData();
	}

	toggle_edit_mode(data)
	{
		data.edit_mode(!data.edit_mode());
	}

	async save_document(data)
	{
		let value = ko.toJS(data);

		if (value.viewing_roles_access === undefined || value.viewing_roles_access === '' || value.viewing_roles_access === null)
		{
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('You cannot save a document without any access rights selected.')});
			return;
		}

		value.viewing_roles_access = value.viewing_roles_access.toString();

		//If the given name/description is empty, use the file's name
		if (!value.name)
			value.name=value.filename;

		let res = await Grape.fetches.postJSON('/general/edit_general_document', value);
		
		Utils.wrap_api_result(res, tr, () => {
			Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully saved document.')});
			this.page.updateData();
		});
	}

	async delete_document(data)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this document?')});
		if (response)
		{
			let value = ko.toJS(data);
			let res = await Grape.fetches.postJSON('/general/delete_general_document', value);
			
			Utils.wrap_api_result(res, tr, () => {
				Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully deleted document.')});
				this.page.updateData();
			});
		}
	}

	async open_document(data)
	{
		let value = ko.toJS(data);
		window.open(value.filename_link, '_blank');
	}

	show_help()
	{
		Grape.dialog.open('GeneralDocumentsHelp', {});
	}
}

class GeneralDocumentsPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new GeneralDocumentsViewModel(this);
	}

	async init()
	{
		document.title = tr('Company Documents');
		window.current_page_title(tr('Company Documents'));

		this.viewModel.doc_types(await Grape.cache.get('GeneralDocumentTypes') || []);
		this.viewModel.access_roles(await Grape.cache.get('AccessRoleLookup') || []);

		// TODO: Confirm is this necessary?
		// Specific role exclusions
		this.viewModel.access_roles.remove('unverified user');
	}

	async updateData()
	{
		this.viewModel.alert_message(tr('Loading...'));
		let res = await Grape.fetches.postJSON('/general/get_general_documents', { employee_id: this.bindings.id });

		// if there are documents this message will not be visible
		this.viewModel.alert_message(tr('No company documents have been found.'));
		
		if (res.general_documents)
		{
			let doc_types = res.general_documents || [];
			
			doc_types.forEach(dt => {
				dt.documents.forEach(d => {
					d.edit_mode = ko.observable(false);
				});
			});

			this.viewModel.general_documents(res.general_documents);
		}
		else
			this.viewModel.general_documents.removeAll();

		Utils.refresh_data_visible_roles();
	}
};

export default {
	route: '[/]general/documents',
	page_class: GeneralDocumentsPage,
	template: template,
	template_filename: 'translation/documents'
}
